// extracted by mini-css-extract-plugin
export default {"addressSection":"XT-z","disabled":"YT-z","sectionButtons":"ZT-z","logo":"_T-z"};